export const JSON_ONE1NW = {
  card_details: {
    cardNumber: "5123450000000008",

    expiryMonth: "12",

    expiryYear: "2024",

    cvv: "100",

    cardName: "test",
  },

  upi_details: {
    VPAaddress: "",
  },

  other_details: {
    udf1: "",

    udf2: "",

    udf3: "",

    udf4: "",

    udf5: "",

    udf6: "",

    udf7: "",
  },

  ship_details: {
    shipAddress: "xyz",

    shipCity: "abc",

    shipState: "test",

    shipCountry: "UAE",

    shipZip: "000001",

    shipDays: "",

    addressCount: "",
  },

  txn_details: {
    agId: "paygate",

    meId: "202307200003",

    orderNo: "A123TEST123A",

    amount: "100",

    country: "ARE",

    currency: "AED",

    transactionType: "SALE",

    sucessUrl:
      "https://macsit.safexpay.ae/simulator/response?meId=202212060006",

    failureUrl:
      "https://macsit.safexpay.ae/simulator/response?meId=202212060006",

    channel: "API",
  },

  item_details: {
    itemCount: "",

    itemValue: "",

    itemCategory: "",
  },

  cust_details: {
    customerName: "Azam",

    emailId: "shahkaidea@safexpay.com",

    mobileNumber: "9876543210",

    uniqueId: "",

    isLoggedIn: "Y",
  },

  pg_details: {
    pg_Id: "64646b7048c64689e99ecd3b",

    paymode: "CC",

    scheme_Id: "2",

    emi_Month: "1",
  },

  bill_details: {
    billAddress: "xyz",

    billCity: "abc",

    billState: "test",

    billCountry: "UAE",

    billZip: "000001",
  },
};
